<template>
        <v-dialog :max-width="Modal.Confirmacao.larguraMaxima" persistent v-model="visibilidadeDialogoSolicitarReadequacao">
            <v-card :min-width="Modal.Confirmacao.larguraMinima" :max-width="Modal.Confirmacao.larguraMaxima">
                <v-card-title class="primary modal-title" primary-title>
                    <span><strong>{{value.descricao}}</strong> | Solicitar Readequação/Doc. Complementar</span>
                    <v-btn flat depressed @click="eventoFecharModalSolicitarReadequacao">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-layout class="d-flex px-3 pt-3 pb-0">
                  <v-flex xs12>
                      <label><strong>Fornecedor</strong></label>
                      <p class="text--secondary">{{value.razaoSocial}}</p>
                  </v-flex>
                  <v-flex xs12>
                      <label><strong>Lance Vencedor</strong></label>
                      <p class="text--secondary">{{value.lanceVencedor | cdCurrency(prefix, casasDecimais)}}{{suffix}}</p>
                  </v-flex>
                </v-layout>

                <v-card-text class="py-0 az-form-content">
                    <v-textarea v-model="value.observacao"
                                :error-messages="errors.collect('Mensagem Readequação Item/Lote')"
                                v-validate="'required'"
                                :name="'Mensagem Readequação Item/Lote'"
                                label="Mensagem"
                                placeholder="Digite aqui a mensagem"
                                rows="4"
                                maxlength="1000"
                                :counter="1000"/>
                </v-card-text>

                <v-card-actions class="px-3 py-2">
                    <v-btn color="botao-cancelar-color" flat outline @click="eventoFecharModalSolicitarReadequacao">
                        Fechar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn id="botaoConfirmar" color="primary" depressed @click="enviarSolicitacaoReadequacao">
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
</template>

<script>
import {Modal} from '@/core/constants'

export default {
    name: 'ModalSolicitarReadequacao',
    $_veeValidate: {
        validator: 'new'
    },
    props: ['value', 'prefix', 'suffix', 'casasDecimais', 'visibilidadeDialogoSolicitarReadequacao'],
    data() {
        return {
            Modal
        }
    },
    methods: {
        async enviarSolicitacaoReadequacao() {
            await this.validarPreenchimento()
            this.$emit('solicitarReadequacao')
            this.limparCampos()
        },
        async validarPreenchimento() {
            const estaValidado = await this.$validator.validate('Mensagem Readequação Item/Lote')
            if (!estaValidado) {
                throw new Error('Preencha uma mensagem descrevendo a sua solicitação.')
            }
        },
        eventoFecharModalSolicitarReadequacao() {
            this.$emit('fecharModalSolicitarReadequacao')
            this.limparCampos()
        },
        limparCampos() {
            this.$validator.reset()
        }
    }
}
</script>

<style scoped lang="stylus">
    .modal-title
        justify-content space-between

        .v-btn
            padding 0
            margin 0
            color #fff
            box-sizing border-box
            min-width 25px

    .botao-primario
        padding 0 25px
        border 1px solid var(--v-primary-base) !important
        background-color var(--v-primary-base) !important
        color #fff !important
        box-sizing border-box
        margin-left 15px !important
</style>